<template>
  <div :class="{ 'bottom-buttons': !top }">
    <div class="row" style="margin-top: 50px; margin-bottom: 50px;">
      <button
        v-if="!top"
        type="submit"
        style="background: none; border: none; margin: auto; display: block;"
        tag="a"
      >
        <div class="btn btn-create btn-save">
          <i class="fa fa-save"></i> &nbsp;Save
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "save-button",
  props: {
    top: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.btn-save {
  width: 250px;
  height: 50px;
  margin: 0 auto;
  padding: 0;
  display: inline-block;
  line-height: 40px;
  text-align: center;
}

.bottom-container {
  position: fixed;
  left: 0;
  bottom: 0px;
  width: 100%;
  color: white;
  text-align: center;
  z-index: 9999;
}

.nav-button {
  display: inline-block;
  padding: 5px 15px 5px 15px;
  margin-left: 13px;
  margin-right: 13px;
  border: solid 1px white;
  font-size: 16px;
  border-radius: 5px;
  background-color: white;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  /* background-color:#2d3f4f; */
  /* color: white; */
}

.nav-button:hover {
  color: #32a6ae;
}

.left-button {
  float: left;
}

.right-button {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/elements/saveButton.vue